import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export const useCancelPlan = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async () => {
			try {
				await api.delete('/user/plan/cancel');
			} catch (error) {
				throw toApiError(error, 'Não foi possível cancelar a assinatura');
			}
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: ['user-plan-summary'] });
		},
	});
};
